import React from 'react';

import type { Section } from '../../../../../models';
import UtilitiesAnnualCosts from './UtilitiesAnnualCosts';
import { WATER_SEWER } from '../../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function WaterSewerAnnualCosts({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesAnnualCosts
      section={section}
      setSectionValues={setSectionValues}
      annualCostsField={WATER_SEWER.FIELD_NAME.ANNUAL_COSTS}
      utilityName="Water/sewer"
      knowAnnualCostsUtilityProviderField={WATER_SEWER.FIELD_NAME.KNOW_ANNUAL_COSTS_UTILITY_PROVIDER}
    />
  );
}

export default WaterSewerAnnualCosts;
